<template>
	<html>
		<head>
			<meta charset="utf-8" />
			<meta name="viewport" content="width=device-width,initial-scale=1.0" />
			<title>Ius Populi</title>

			<!-- Styles -->
			<link rel="stylesheet" href="static/css/bootstrap.min.css" />

			<!-- Favicon -->
			<link rel="apple-touch-icon" sizes="120x120" href="static/favicon/apple-touch-icon.png" />
			<link rel="icon" type="image/png" sizes="32x32" href="static/favicon/favicon-32x32.png" />
			<link rel="icon" type="image/png" sizes="16x16" href="static/favicon/favicon-16x16.png" />
			<link rel="manifest" href="static/favicon/site.webmanifest" />
			<link rel="mask-icon" href="static/favicon/safari-pinned-tab.svg" color="#5bbad5" />
			<meta name="msapplication-TileColor" content="#00aba9" />
			<meta name="theme-color" content="#ffffff" />
		</head>
		<body>
			<div id="app">
				<div style="text-align: center; margin: 100px auto">
					<img src="static/images/logo-full.png" alt="Ius Populi" class="" />
				</div>
				<div style="text-align: center; margin: 0 auto">
					<h1 style="color: #4e498b"><b>Sei offline</b></h1>
					<span style="color: #00849e"><i>Si prega di attendere che venga ripristinata la connessione...</i></span>
				</div>
			</div>
		</body>
	</html>
</template>

<script>
export default {
	name: 'Offline',

	mounted() {
		this.setOnlineListener()
	},
	beforeDestroy() {
		window.removeEventListener('online', this.onlineListener)
	},
	methods: {
		setOnlineListener() {
			window.addEventListener('online', this.onlineListener)
		},
		onlineListener() {
			this.$store.commit('setOnlineStatus', true)

			const targetPath = window.location.href.replace(window.location.origin, '')

			// Go to target path
			this.$router.replace(targetPath)
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/views/PageOffline.vue